export default __webpack_public_path__ + "static/design-poster-c27c26ceeae6325eca4d62abeb566d00.avif";